// Module
var code = `<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="arpu.ArppuByMonthsChart"></bfg-chart>
    </div>
</div>
<div class="row">
    <table class="table">
        <tr>
            <th>Date</th>
            <th>Installs</th>
            <th>1</th>
            <th>2</th>
            <th>3</th>
            <th>4</th>
            <th>5</th>
            <th>6</th>
            <th>7</th>
            <th>8</th>
            <th>9</th>
            <th>10</th>
            <th>11</th>
            <th>12</th>
            <th>13</th>
            <th>14</th>
            <th>15</th>
            <th>16</th>
            <th>17</th>
            <th>18</th>
            <th>19</th>
            <th>20</th>
            <th>21</th>
            <th>22</th>
            <th>23</th>
            <th>24</th>
        </tr>
        <tr style="background-color: #FFEBCD">
            <td>Average</td>
            <td>{{apply(data[0].installs)}}</td>
            <td>{{apply(data[0].val1)}}</td>
            <td>{{apply(data[0].val2)}}</td>
            <td>{{apply(data[0].val3)}}</td>
            <td>{{apply(data[0].val4)}}</td>
            <td>{{apply(data[0].val5)}}</td>
            <td>{{apply(data[0].val6)}}</td>
            <td>{{apply(data[0].val7)}}</td>
            <td>{{apply(data[0].val8)}}</td>
            <td>{{apply(data[0].val9)}}</td>
            <td>{{apply(data[0].val10)}}</td>
            <td>{{apply(data[0].val11)}}</td>
            <td>{{apply(data[0].val12)}}</td>
            <td>{{apply(data[0].val13)}}</td>
            <td>{{apply(data[0].val14)}}</td>
            <td>{{apply(data[0].val15)}}</td>
            <td>{{apply(data[0].val16)}}</td>
            <td>{{apply(data[0].val17)}}</td>
            <td>{{apply(data[0].val18)}}</td>
            <td>{{apply(data[0].val19)}}</td>
            <td>{{apply(data[0].val20)}}</td>
            <td>{{apply(data[0].val21)}}</td>
            <td>{{apply(data[0].val22)}}</td>
            <td>{{apply(data[0].val23)}}</td>
            <td>{{apply(data[0].val24)}}</td>
        </tr>
        <tr ng-repeat="day in data.slice(1, data.length)">
            <td>{{day.date}}</td>
            <td>{{day.installs}}</td>
            <td ng-style="{'background-color': apply_color(day.val1, 'val1')}">{{apply(day.val1)}}</td>
            <td ng-style="{'background-color': apply_color(day.val2, 'val2')}">{{apply(day.val2)}}</td>
            <td ng-style="{'background-color': apply_color(day.val3, 'val3')}">{{apply(day.val3)}}</td>
            <td ng-style="{'background-color': apply_color(day.val4, 'val4')}">{{apply(day.val4)}}</td>
            <td ng-style="{'background-color': apply_color(day.val5, 'val5')}">{{apply(day.val5)}}</td>
            <td ng-style="{'background-color': apply_color(day.val6, 'val6')}">{{apply(day.val6)}}</td>
            <td ng-style="{'background-color': apply_color(day.val7, 'val7')}">{{apply(day.val7)}}</td>
            <td ng-style="{'background-color': apply_color(day.val8, 'val8')}">{{apply(day.val8)}}</td>
            <td ng-style="{'background-color': apply_color(day.val9, 'val9')}">{{apply(day.val9)}}</td>
            <td ng-style="{'background-color': apply_color(day.val10, 'val10')}">{{apply(day.val10)}}</td>
            <td ng-style="{'background-color': apply_color(day.val11, 'val11')}">{{apply(day.val11)}}</td>
            <td ng-style="{'background-color': apply_color(day.val12, 'val12')}">{{apply(day.val12)}}</td>
            <td ng-style="{'background-color': apply_color(day.val13, 'val13')}">{{apply(day.val13)}}</td>
            <td ng-style="{'background-color': apply_color(day.val14, 'val14')}">{{apply(day.val14)}}</td>
            <td ng-style="{'background-color': apply_color(day.val15, 'val15')}">{{apply(day.val15)}}</td>
            <td ng-style="{'background-color': apply_color(day.val16, 'val16')}">{{apply(day.val16)}}</td>
            <td ng-style="{'background-color': apply_color(day.val17, 'val17')}">{{apply(day.val17)}}</td>
            <td ng-style="{'background-color': apply_color(day.val18, 'val18')}">{{apply(day.val18)}}</td>
            <td ng-style="{'background-color': apply_color(day.val19, 'val19')}">{{apply(day.val19)}}</td>
            <td ng-style="{'background-color': apply_color(day.val20, 'val20')}">{{apply(day.val20)}}</td>
            <td ng-style="{'background-color': apply_color(day.val21, 'val21')}">{{apply(day.val21)}}</td>
            <td ng-style="{'background-color': apply_color(day.val22, 'val22')}">{{apply(day.val22)}}</td>
            <td ng-style="{'background-color': apply_color(day.val23, 'val23')}">{{apply(day.val23)}}</td>
            <td ng-style="{'background-color': apply_color(day.val24, 'val24')}">{{apply(day.val24)}}</td>
        </tr>
    </table>
</div>
`;
// Exports
module.exports = code;